/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-08-14 09:59:22
 * @LastEditors: linxi
 * @LastEditTime: 2024-04-19 11:04:46
 */

//医保人均费用打印单
export function printPeopleSalesBody(data: any) {
  const tenantName = data?.tenantName
  const timeHead = data?.timeHead
  const timeTail = data?.timeTail
  const datas = data?.dataList || []

  const columns: any[] = [
    { title: '名称', width: '10%', render: (r: any) => r?.name ?? '' },
    { title: '医保小险种', width: '8%', render: (r: any) => r?.cbxz ?? '' },
    { title: '人次', width: '5%', render: (r: any) => r?.personTime ?? '' },
    { title: '人头', width: '5%', render: (r: any) => r?.headCount ?? '' },
    { title: '人次人头比', width: '8%', render: (r: any) => r?.personHeadScale ?? '' },
    { title: '医保总金额', width: '8%', render: (r: any) => r?.totalInsurancePayAmount?.toFixed(2) ?? '' },
    { title: '报销总金额', width: '8%', render: (r: any) => r?.totalBaoxiao?.toFixed(2) ?? '' },
    { title: '统筹基金', width: '7%', render: (r: any) => r?.totalJijin?.toFixed(2) ?? '' },
    { title: '当年账户支出', width: '9%', render: (r: any) => r?.totalDangnianzh?.toFixed(2) ?? '' },
    { title: '总金额(元)', width: '8%', render: (r: any) => r?.totalRetail?.toFixed(2) ?? '' },
    { title: '人均基金', width: '7%', render: (r: any) => r?.totalJijinPer?.toFixed(2) ?? '' },
    { title: '平均值(人次)', width: '9%', render: (r: any) => r?.personTimeAvgAmount?.toFixed(1) ?? '' },
    { title: '平均值(人头)', width: '8%', render: (r: any) => r?.headCountAvgAmount?.toFixed(1) ?? '' },
  ]

  const cell = (value: any, w: string, isLast: boolean) =>
    `<div style="line-height:25px;padding-left:2px;padding-right:2px;word-break:break-all;width:${w};text-align:center;box-sizing:border-box;${isLast ? '' : 'border-right:1px solid #000'}">${value}</div>`

  const headerHtml = columns
    .map((c, i) => cell(c.title, c.width, i === columns.length - 1))
    .join('')

  let rowHtml = ''
  for (const r of datas) {
    const cells = columns
      .map((c, i) => cell(c.render(r), c.width, i === columns.length - 1))
      .join('')
    rowHtml +=
      `<div style="min-height:28px;font-size:13px;display:flex;clear:left;border-left:1px solid #000;border-right:1px solid #000;border-bottom:1px solid #000">` +
      cells +
      '</div>'
  }

  const timeHeadText = (timeHead || '').toString().split(' ')[0]
  const timeTailText = (timeTail || '').toString().split(' ')[0]

  const content =
    '<div style="margin-left:10px;margin-right:10px">' +
    `<h3 style="text-align:center;margin-bottom:5px;">${tenantName}</h3>` +
    '<h3 style="text-align:center;margin-top:5px;margin-bottom:5px;">医&nbsp;&nbsp;保&nbsp;&nbsp;人&nbsp;&nbsp;均&nbsp;&nbsp;费&nbsp;&nbsp;用</h3>' +
    '<div style="font-size:14px;display:flex;text-align:left;margin-bottom:6px">' +
    `<div style="font-size:14px;width:100%;padding-left:10px;display:flex;justify-content:flex-end;">日期:<font style="font-size:14px;word-break:break-all;padding-left:10px">${timeHeadText}至${timeTailText}</font></div>` +
    '</div>' +
    `<div style="font-weight:bold;min-height:25px;line-height:25px;font-size:14px;display:flex;clear:left;border:1px solid #000">${headerHtml}</div>` +
    rowHtml +
    '</div>'

  return content
}
